import React from "react";
import '../../assets/css/starRating.css'


const StarRating = ({ rating, className = '' }) => {
    const totalStars = 5;
    const fullStars = Math.floor(rating);
    const emptyStars = totalStars - fullStars;
    const stars = [];

    for (let i = 0; i < fullStars; i++) {
        stars.push(
            <span key={`full-${i}`} className="star-rating__star">★</span>
        );
    }
    for (let i = 0; i < emptyStars; i++) {
        stars.push(
            <span key={`empty-${i}`} className="star-rating__star star-rating__star--empty">☆</span>
        );
    }

    return <div className={`star-rating ${className}`}>{stars}</div>;
};

export default StarRating;